import Stomp from "stompjs";
import SockJS from "sockjs-client";
import store from "@/store";
import Vue from "vue";

const WebSocketPlugin = {
  install(Vue, options) {
    Vue.prototype.$socket = new Vue({
      data() {
        return {
          stompClient: null,
          isConnected: false,
        };
      },
      methods: {
        connect() {
          return new Promise((resolve, reject) => {
            if (this.isConnected) {
              console.log(111111);
              resolve(this.stompClient);
            } else {
              console.log(222222);
              this.stompClient = Stomp.over(new SockJS(window.location.protocol + '//' + store.state.user.notifyUrl + '/ws?token=' + store.state.user.token))
              this.stompClient.debug = function (str) {
                // console.log(str)
              }
              this.stompClient.connect({}, () => {
                this.isConnected = true; // 更新连接状态
                resolve(this.stompClient);
              }, error => {
                this.isConnected = false; // 更新连接状态
                this.connect();
              });
            }
          });
        },
        disconnect() {
          if (this.isConnected) {
            this.stompClient.disconnect();
            this.stompClient = null;
            this.isConnected = false;
          }
        },
        sendMessage(topic, message) {
          if (this.isConnected) {
            // 发送私有消息
            this.stompClient.send(topic, {}, JSON.stringify(message));
          }
        }
      }
    });
  }
}

Vue.use(WebSocketPlugin);
